import { StrictMode } from 'react';
import { ChakraProvider, defaultSystem } from '@chakra-ui/react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { getLocale } from './i18n/index.js';
import 'react-phone-number-input/style.css';
import './styles/atomfit.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');
document.documentElement.lang = getLocale();

createRoot(root).render(
  <StrictMode>
    <ChakraProvider value={defaultSystem}>
      <App />
    </ChakraProvider>
  </StrictMode>,
);
